import { Pressable, PressableProps, StyleSheet } from 'react-native'
import Animated, { useSharedValue, useAnimatedStyle, withTiming } from 'react-native-reanimated'
import * as Haptics from 'expo-haptics'
import { Platform } from 'react-native'
import { animation } from '../theme'

const AnimatedPressable = Animated.createAnimatedComponent(Pressable)

interface PressableScaleProps extends PressableProps {
  /** Scale factor when pressed. Default 0.97 */
  activeScale?: number
  /** Haptic feedback type. 'light' | 'medium' | 'none'. Default 'light' */
  haptic?: 'light' | 'medium' | 'none'
}

export default function PressableScale({
  activeScale = 0.97,
  haptic = 'light',
  onPressIn,
  onPressOut,
  style,
  ...props
}: PressableScaleProps) {
  const scale = useSharedValue(1)

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ scale: scale.value }],
  }))

  return (
    <AnimatedPressable
      {...props}
      style={[animatedStyle, style as any]}
      onPressIn={(e) => {
        scale.value = withTiming(activeScale, { duration: animation.fast })
        if (haptic !== 'none' && Platform.OS !== 'web') {
          Haptics.impactAsync(
            haptic === 'medium' ? Haptics.ImpactFeedbackStyle.Medium : Haptics.ImpactFeedbackStyle.Light
          ).catch(() => {})
        }
        onPressIn?.(e)
      }}
      onPressOut={(e) => {
        scale.value = withTiming(1, { duration: animation.fast })
        onPressOut?.(e)
      }}
    />
  )
}
